import { useEffect, useRef, useState } from "react";
import { PlayerTrafficProps } from "./player.traffic.props";

export const PlayerTraffic: React.FC<PlayerTrafficProps> = ({ trafficUsed, logo, message, startTime }) => {

    const [show, setShow] = useState(false);
    const timer = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {

        const clearTimer = () => {
            if (timer && timer.current) {
                clearInterval(timer.current);
            }
        };

        const checkShow = () => {
            if (startTime === null || !trafficUsed) {
                setShow(false);
                clearTimer();
            }
            else {
                const now = new Date();
                const diff = (now.getTime() - startTime.getTime()) / 1000;
                const seconds = Math.abs(Math.round(diff));
                setShow(seconds <= 5);
                if (seconds > 5) clearTimer();
            }
        };

        clearTimer();
        checkShow();
        if (trafficUsed && startTime) timer.current = setInterval(checkShow, 1000);

        return () => clearTimer();

    }, [startTime, trafficUsed]);

    if (!show) return null;

    return (
        <div className="player-message-wrapper">
            <div className="player-message">
                {
                    logo &&
                    <div className="logo" style={{ backgroundImage: `url(${logo})` }}></div>
                }
                <span>{message}</span>
            </div>
        </div>
    );

};